export const PROCEED_EVENT_NAME = 'proceed'
export const LOAD_EVENT_NAME = 'load'
export const COUNTRY_CODE = 'QA'
export const FLOW_CONTACTS_EMAIL_TEST_ID = 'flow-contacts-email'
export const FLOW_CONTACTS_PHONE_TEST_ID = 'flow-contacts-phone'
export const FLOW_CONTACTS_PROCEED_TEST_ID = 'flow-contacts-proceed'
